import { Injectable } from '@angular/core';
import { CreditQuestionnaire } from '../Models/TaxCreditQuestionnaire';
import { EnumMapper } from '../Models/EnumMapper';
import { DennysFlow, Question, WOTCCategory } from '../Models/dennysFlow';
import { DisplayLanguage, Verbiage } from '../Models/DisplayLanguage';

@Injectable()
export class QuestionProcessingService {
  forward: boolean;
  model : CreditQuestionnaire;
  dennys : DennysFlow = new DennysFlow();
  hasBenefits : boolean;
  language : DisplayLanguage = 0; //english by default
  StateArray : string[] = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI','SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']
  QuestionsAnswered : Array<BreadCrumb> = [];
  private NonFlowVerbiage : Verbiage[];
  constructor() {
    this.model = new CreditQuestionnaire();
    this.dennys = new DennysFlow();
    this.Questions = [
      { dennys: null, 
        Category: WOTCCategory.TANF, 
        Name: 'ReceivedTANF', 
        Answer: null, 
        Get() : any { return this.dennys.ReceivedTANF }, 
        Set(val:any) : any { 
          this.Answered = true; 
          this.dennys.ReceivedTANF = val;
          if(this.dennys.ReceivedTANF == false) this.dennys.TANFPayments = null; }, 
        Answered: false, 
        show(): boolean { return true; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Have you or your family received Temporary Assistance for Needy Families(TANF) within the last 18 months.'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Han recibido usted o su familia Asistencia Temporal para Familias Necesitadas (TANF) en los últimos 18 meses?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.TANF, 
        Name: 'TANFPayments', 
        Answer: null, 
        Get() : any { return this.dennys.TANFPayments }, 
        Set(val:any) : any { this.Answered = true; this.dennys.TANFPayments = val; }, 
        Answered: false, 
        show(): boolean { return this.dennys.ReceivedTANF },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'How many months of TANF payments have you received within the last 18 months?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Cuántos meses de pagos de TANF ha recibido en los últimos 18 meses?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.SNAP, 
        Name: 'ReceivedSNAP',
        Answer: null, 
        Get() : any { return this.dennys.ReceivedSNAP }, 
        Set(val:any) : any { 
        this.Answered = true;  
        this.dennys.ReceivedSNAP = val;
        if(this.dennys.ReceivedSNAP == false) this.dennys.SNAPPayments = null; }, 
        Answered: false, 
        show(): boolean { return true; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Have you or your family received Supplemental Nutrition Assistance Program (SNAP) benefits within the last 15 months.'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Han recibido usted o su familia beneficios del Programa de Asistencia Nutricional Suplementaria (SNAP) en los últimos 15 meses?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.SNAP, 
        Name: 'SNAPPayments', 
        Answer: null, 
        Get() : any { return this.dennys.SNAPPayments }, 
        Set(val:any) : any { this.Answered = true; this.dennys.SNAPPayments = val; }, 
        Answered: false, 
        show(): boolean { return this.dennys.ReceivedSNAP },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'How many months of SNAP payments have you received within the last 15 months?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Cuántos meses de pagos SNAP recibió en los últimos 15 meses?'}
        ]},
      { dennys: null, 
        Category: WOTCCategory.SNAP, 
        Name: 'AgeRangeValid', 
        Answer: null, 
        Get() : any { return this.dennys.AgeRangeValid }, 
        Set(val:any) : any { this.Answered = true; this.dennys.AgeRangeValid = val; }, 
        Answered: false, 
        show(): boolean { return (this.dennys.ReceivedSNAP && this.dennys.SNAPPayments)},
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Are you atleast 18 years of age but not age 40 or older?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Tienes al menos 18 años pero no tienes 40 años o más?'}
        ]},
      { dennys: null, 
        Category: WOTCCategory.SSI, 
        Name: 'ReceivedSSI', 
        Answer: null, 
        Get() : any { return this.dennys.ReceivedSSI }, 
        Set(val:any) : any { this.Answered = true; this.dennys.ReceivedSSI = val; },
        Answered: false, 
        show(): boolean { return true; }, 
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Have you or your family received Supplemental Security Income (SSI) in the last 60 days.'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Usted o su familia han recibido Seguridad de Ingreso Suplementario (SSI) en los últimos 60 días?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.UNEMPLOYMENT, 
        Name: 'Unemployed', 
        Answer: null, 
        Get() : any { return this.dennys.Unemployed }, 
        Set(val:any) : any { this.Answered = true; this.dennys.Unemployed = val; }, 
        Answered: false, 
        show(): boolean { return true; }, 
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Have you been unemployed and received unemployment compensation within the last 12 months?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Ha estado desempleado y recibió compensación por desempleo en los últimos 12 meses?'}
        ]},
      { dennys: null, 
        Category: WOTCCategory.UNEMPLOYMENT, 
        Name: 'WeeksUnemployed', 
        Answer: null, 
        Get() : any { return this.dennys.WeeksUnemployed }, 
        Set(val:any) : any { this.Answered = true; this.dennys.WeeksUnemployed = val; },
        Answered: false, 
        show(): boolean { return this.dennys.Unemployed; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'How many weeks have you been unemployed?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Cuántas semanas has estado desempleado?'}
        ]},
      { dennys: null, 
        Category: WOTCCategory.UNEMPLOYMENT, 
        Name: 'WeeksUnemployedAndCompensated', 
        Answer: null, 
        Get() : any { return this.dennys.WeeksUnemployedAndCompensated }, 
        Set(val:any) : any { this.Answered = true; this.dennys.WeeksUnemployedAndCompensated = val; },
        Answered: false, 
        show(): boolean { return this.dennys.Unemployed && this.dennys.WeeksUnemployed; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'How many weeks of unemployment compensation have you received?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Cuántas semanas de compensación por desempleo ha recibido?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.MILITARY, 
        Name: 'MilitaryService', 
        Answer: null, 
        Get() : any { return this.dennys.MilitaryService }, 
        Set(val:any) : any { this.Answered = true; this.dennys.MilitaryService = val; },
        Answered: false, 
        show(): boolean { return true; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Have you served in the U.S. military?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Usted ha servido en el ejército EE.UU?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.MILITARY, 
        Name: 'Discharged', 
        Answer: null, 
        Get() : any { return this.dennys.Discharged }, 
        Set(val:any) : any { this.Answered = true; this.dennys.Discharged = val; },
        Answered: false, 
        show(): boolean { return this.dennys.MilitaryService; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Were you discharged or released from active duty in the past year?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Fue despedido o liberado del servicio activo el año pasado?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.MILITARY, 
        Name: 'EntitledToCompensation', 
        Answer: null, 
        Get() : any { return this.dennys.EntitledToCompensation }, 
        Set(val:any) : any { this.Answered = true; this.dennys.EntitledToCompensation = val; },
        Answered: false, 
        show(): boolean { return this.dennys.MilitaryService; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Are you entitled to compensation for a service connected disability?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Tiene derecho a una compensación por una discapacidad relacionada con el servicio?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.VOCATIONALREHAB, 
        Name: 'VocationalRehab', 
        Answer: null, 
        Get() : any { return this.dennys.VocationalRehab }, 
        Set(val:any) : any { this.Answered = true; this.dennys.VocationalRehab = val; },
        Answered: false, 
        show(): boolean { return true; },
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Were you referred by a vocational rehabilitation agency, Ticket to Work Program, or by the Department of Veteran Affairs?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Lo remitió una agencia de rehabilitación vocacional, el Programa Boleto para Trabajar o el Departamento de Asuntos de Veteranos?'}
        ]},

      { dennys: null, 
        Category: WOTCCategory.FELON, 
        Name: 'FelonyConviction', 
        Answer: null, 
        Get() : any { return this.dennys.FelonyConviction }, 
        Set(val:any) : any { this.Answered = true; this.dennys.FelonyConviction = val;},
        Answered: false, 
        show(): boolean { return true; }, 
        Verbiage: [
          { Language : DisplayLanguage.ENGLISH, Verbiage: 'Were you convicted of a felony or released from prison in the last year?'},
          { Language : DisplayLanguage.SPANISH, Verbiage: '¿Fue condenado por un delito grave o liberado de prisión en el último año?'}
        ]}
      ];
    this.Questions.forEach((q) => { 
      q.dennys = this.dennys});
    this.NonFlowVerbiage = [
      { Language: DisplayLanguage.ENGLISH, Verbiage: "Our company participates in federal and state incentive programs which help keep our cost of doing business at a minimum. We would appreciate if you would answer the following questions.", Component : 'Disclaimer' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'We want to stress that your answers on this questionnaire will in no way affect your eligibility for employment or any benefits you or your family may be receiving. If you choose to answer these questions, your responses will be kept confidential.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'If you would like to decline the screening, click \'Opt-Out\' below. Otherwise, click \'Next\'', Component : 'Disclaimer' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Participamos en el programa de Crédito Tributario de Oportunidad Laboral del gobierno federal. Sus respuestas a las siguientes preguntas se utilizan para determinar la elegibilidad del crédito tributario.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Esta información se mantiene en estricta confidencialidad y no tendrá un impacto negativo en el proceso de contratación.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Gracias por su participación.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Dear Applicant', Component: 'Header' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Applicant Survey', Component: 'Header' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Thank you for completing this survey!', Component: 'Header' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Querido solicitantee', Component: 'Header' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Encuesta del solicitante', Component: 'Header' },
      { Language: DisplayLanguage.SPANISH, Verbiage: '¡Gracias por completar esta encuesta!', Component: 'Header' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Thank you for taking the time to complete this survey related to the Work Opportunity Tax Credit Program.', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'If you agree with the following declaration, enter your full name below and click the "Electronically Sign" button. Your information has been used to complete the following forms: ', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Under penalty of perjury, I delcare I have given the above information on or before the day I was offered a job. To the best of my knowledge, the information is correct and complete.', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Enter your full name.', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Electronically Sign', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'He revisado la copia en línea del formulario 8850 y certifico que toda la información proporcionada por mí es verdadera, completa y correcta.', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Bajo las penalidades de la ley por perjurio, declaro que presenté esta información al empleador en o antes de que se le ofrezca un trabajo con el empleador.', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Usando la firma electrónica a continuación, ingrese su nombre como lo haría legalmente en el espacio provisto y seleccione el botón Aceptar.', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Tu firma aquí', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Aceptar y enviar copia <br />a un correo electrónico', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Employee Information', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'First Name', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Last Name', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Email', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Phone', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'SSN', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'DOB', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Address', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Información del empleado:', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Nombre Primero', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Apellido', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Email', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Teléfono', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Número de seguridad social', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Fecha de nacimiento', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Dirección', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Next', Component: 'Buttons' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Back', Component: 'Buttons' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Please complete all fields before continuing.', Component: 'Buttons' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Continuar', Component: 'Buttons' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Regresa', Component: 'Buttons' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Por favor complete todos los campos antes de la continuación', Component: 'Buttons' },
      
      
    ];
  }
  
   Questions : Array<Question>;
   SelectVerbiage(comp : string) : Verbiage[] {
    return this.NonFlowVerbiage.filter((v) => {
      return v.Language == this.language && v.Component == comp;
    })
   }
}

export class BreadCrumb{
  id: string;
  answered: boolean;
}






// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/services/question-processing.service.ts